// extracted by mini-css-extract-plugin
export var boxItems = "_7y-1";
export var boxItemsLg = "_7y-2";
export var button = "_7y-7";
export var buttonHoverless = "_7y-9";
export var buttonLg = "_7y-8";
export var filterGroupBox = "_7y-0";
export var icon = "_7y-3";
export var iconSecondary = "_7y-6";
export var iconWrapper = "_7y-4";
export var iconWrapperLg = "_7y-5";
export var truncatedLabel = "_7y-a";